import React from "react"
import SharePanel from "../components/share"
import { Link } from "gatsby"
import { UrlsUtils } from "../utils/UrlsUtils";


class DesktopPostHeader extends React.Component {

    // constructor(props) {
    //   super(props);
    //   console.log('DesktopPostHeader constructor', props);
    // }

    render() {
        return (
            <div className="show_desktop byline desktop-header-bar" style={{
                // display: "flex",
                display: "none",
                background:"white",
                position: "fixed",
                top: "0",
                zIndex:"99"}}>
                <div className="byline mag_fixed_header" style={{
                    width: "100%",
                    height: "92px",
                    background:"white"}}>
                    <div className="posted-on" style={{
                        display: "flex", marginTop:"20px", marginBottom:"15px"}}>
                        <Link style={{marginRight: 'auto'}} to={
                            UrlsUtils.ensure_wp_admin_url(this.props.primary_category_override_link)
                          }
                        >
                        <div className="newmag_mobile_primary_category" style={{
                            marginTop: "5px",
                            marginLeft: "15px",
                            minWidth: "68px",
                            fontSize: "13px",
                            borderRadius: "5px",
                            backgroundColor: (
                                (
                                    this.props.primary_category_override &&
                                    this.props.array_colors[this.props.primary_category_override.toLowerCase()]
                                ) ?
                                    this.props.array_colors[this.props.primary_category_override.toLowerCase()] : "gray"
                            ),
                            color: "white",
                            textAlign: "center",
                            width: "fit-content",
                            padding: "10px"
                        }}>{this.props.primary_category_override}</div></Link>
                        <SharePanel
                            float="right"
                            margin=""
                            title={this.props.title}
                            components_name_md5={"_header" + this.props.uri}
                            //img={this.props.featuredImage?this.props.featuredImage.node.mediaItemUrl:""}
                            img={this.props.featuredImage ?
                                typeof this.props.featuredImage.mediaItemUrl!="undefined" ?
                                this.props.featuredImage.node.mediaItemUrl:this.props.featuredImage:""}
                            author={this.props.author && this.props.author.name? this.props.author.name: ""}
                            video={JSON.stringify(this.props.video_embedded_home)}
                            is_media={this.props.video_content}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default DesktopPostHeader;
